import styled from 'styled-components';

export const GaugeContainer = styled.div<{ meetsExpectation?: boolean }>`
  background: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 6px;
  padding-top: 28px;
  padding-right: 8px;
  padding-left: 8px;
  padding-bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    margin-bottom: 2px;
  }

  h2 {
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height */

    text-align: center;
    text-transform: uppercase;
  }

  .ant-progress-text {
    font-size: 0.75em;
  }
`;
